import { Alert, Button, Col, Form, Row } from "antd";

import { FormItemInput, FormItemSelect } from "../../ant-wrapper/form-item";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { fetchAllCities } from "../../../services/location";

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

export default function LocaisForm({
  onFinish,
  setError,
  error,
  initialValues = {},
  loading = false,
  viewMode = false,
}) {
  const [form] = Form.useForm();
  const onEdit = () => {
    setError();
  };
  const [cities, setCities] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { estados: states } = useSelector((state) => state.estados);
  async function fetchCities(value) {
    const citiesData = await fetchAllCities(value);
    setCities(citiesData);
  }

  const fetchStates = async () => {
    try {
      setIsLoading(true);
      if (form.getFieldsValue().estado) {
        const siglaEstado = form.getFieldsValue().estado;
        fetchCities(siglaEstado);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchStates();
  }, []);
  const handleChange = (value) => {
    fetchCities(value);
  };
  return (
    <>
      {error && (
        <>
          <Alert message={error} type="error" />
          <br />
        </>
      )}
      <Form
        form={form}
        onChange={onEdit}
        name="register"
        onFinish={onFinish}
        scrollToFirstError
        initialValues={initialValues}
      >
        <Row gutter={[8, 8]}>
          <Col span={6}>
            <FormItemInput
              {...formItemLayout}
              name="descricao"
              rules={[
                { required: true, message: "Campo não pode ser vazio" },
                { max: 150, message: "Tamanho máximo de 150 caracteres" },
              ]}
              label="Descrição"
              viewMode={viewMode}
            />
          </Col>
          <Col span={2}>
            <FormItemSelect
              {...formItemLayout}
              name={"estado"}
              label="Estado"
              items={states}
              itemsLabel="nome"
              itemsValue="sigla"
              viewMode={viewMode}
              onChangeSelect={handleChange}
              required
            />
          </Col>
          <Col span={4}>
            <FormItemSelect
              {...formItemLayout}
              name={"cidade"}
              label="Cidade"
              items={cities}
              itemsLabel="nome"
              itemsValue="nome"
              viewMode={viewMode}
              required
            />
          </Col>
        </Row>
        {!viewMode && (
          <Form.Item>
            <Button loading={isLoading} type="primary" htmlType="submit">
              Enviar
            </Button>
          </Form.Item>
        )}
      </Form>
    </>
  );
}
